/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Fix: Bazaarvoice rating popover "Read X Reviews" button bounces back on
  // second keyboard use. BV refocuses the stars trigger after scrolling to
  // reviews, which pulls the viewport back up. We intercept focus on the
  // trigger and use preventScroll when it happens right after a review-scroll.
  (function fixBvReviewScrollBounce() {
    var scrollingToReviews = false;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-bv-modal] .bv_button_buttonFull');
      if (!btn) return;

      scrollingToReviews = true;

      // Give BV time to do its scroll + focus dance, then re-scroll to reviews
      setTimeout(function() {
        var reviewsSection = document.querySelector('[data-bv-show="reviews"]')
          || document.querySelector('#bv-reviews')
          || document.querySelector('[id*="bazaarvoice"]')
          || document.querySelector('.bv-content-container');

        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        scrollingToReviews = false;
      }, 300);
    }, true);

    // Intercept BV's focus-return to the stars trigger with preventScroll
    document.addEventListener('focus', function(e) {
      if (!scrollingToReviews) return;
      var trigger = e.target.closest('.bv_ratings_summary');
      if (trigger) {
        e.target.blur();
      }
    }, true);
  })();



  // Fix: Product modal dialogs start with aria-hidden="true" inert, but
  // PopupActions only removes inert when opening -- aria-hidden stays, which
  // prevents VoiceOver/TalkBack from reaching links inside the dialog.
  // This toggles aria-hidden alongside inert on all product-modal dialogs.
  (function fixDialogAriaHidden() {
    // Watch for inert attribute changes on dialogs as a proxy for open/close
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName !== 'inert') return;
        var dialog = m.target;
        if (dialog.hasAttribute('inert')) {
          dialog.setAttribute('aria-hidden', 'true');
        } else {
          dialog.removeAttribute('aria-hidden');
        }
      });
    });

    document.querySelectorAll('dialog.product-modal').forEach(function(dialog) {
      observer.observe(dialog, { attributes: true, attributeFilter: ['inert'] });
    });

    // Also handle dialogs added later (e.g. quick-add modals)
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var dialogs = node.matches && node.matches('dialog.product-modal')
            ? [node]
            : (node.querySelectorAll ? node.querySelectorAll('dialog.product-modal') : []);
          dialogs.forEach(function(dialog) {
            observer.observe(dialog, { attributes: true, attributeFilter: ['inert'] });
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();


  // Fix: Mobile menu drawer doesn't hide background content from screen
  // readers. TalkBack's explore-by-touch can reach the logo, search icon,
  // and page content behind the open drawer. Add inert to background
  // elements when the drawer opens.
  (function fixDrawerBackgroundInert() {
    function setBackgroundInert(inert) {
      var header = document.querySelector('header.theme__header');
      var main = document.getElementById('MainContent');
      var footer = document.querySelector('.footer-sections');
      var preFooter = document.querySelector('.pre-footer-sections, [class*="pre-footer"]');

      [header, main, footer, preFooter].forEach(function(el) {
        if (!el) return;
        if (inert) {
          el.setAttribute('inert', '');
          el.setAttribute('aria-hidden', 'true');
        } else {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        }
      });
    }

    document.addEventListener('theme:drawer:open', function() {
      setBackgroundInert(true);
    });

    document.addEventListener('theme:drawer:close', function() {
      setBackgroundInert(false);
    });
  })();


  // Fix: Mobile search (TalkBack) -- role="option" divs wrap the result
  // links. TalkBack focuses the div, so double-tap fires click on the div
  // instead of the <a> inside. This adds click handlers to navigate.
  // Also makes the live region announce result counts.
  (function fixSearchResultsAccessibility() {
    var resultsContainer = document.querySelector('[data-predictive-search-results]');
    if (!resultsContainer) return;

    var observer = new MutationObserver(function() {
      // TalkBack double-tap fires click on the role="option" div, not the
      // <a> inside. Add click handler so tapping an option navigates.
      var options = resultsContainer.querySelectorAll('[role="option"]');
      options.forEach(function(option) {
        if (option.hasAttribute('data-click-init')) return;
        option.setAttribute('data-click-init', '');
        option.addEventListener('click', function(e) {
          if (e.target.closest('a')) return;
          var link = option.querySelector('a[href]');
          if (link) link.click();
        });
      });

      // Make the live region visible to screen readers
      var liveRegion = resultsContainer.querySelector('[data-predictive-search-live-region-count-value]');
      if (liveRegion && liveRegion.classList.contains('hidden')) {
        liveRegion.classList.remove('hidden');
        liveRegion.classList.add('visually-hidden');
      }
    });

    observer.observe(resultsContainer, { childList: true, subtree: true });
  })();


  // Fix: Product grid swatch/sibling option thumbnails are only accessible
  // via mouse hover. This makes the "X colors" count trigger focusable and
  // reveals swatches on focus, and makes sibling product divs keyboard
  // navigable.
  (function fixSwatchKeyboardNav() {
    function initSwatchTriggers() {
      // Pattern A: Color swatches -- [data-swatch-count] triggers [data-grid-swatch-form]
      document.querySelectorAll('[data-swatch-count]').forEach(function(count) {
        if (count.hasAttribute('data-kb-init')) return;
        count.setAttribute('data-kb-init', '');
        count.setAttribute('tabindex', '0');
        count.setAttribute('role', 'button');
        count.setAttribute('aria-expanded', 'false');

        var productInfo = count.closest('[data-product-information]');
        if (!productInfo) return;
        var form = productInfo.querySelector('[data-grid-swatch-form]');
        if (!form) return;

        count.addEventListener('focus', function() {
          productInfo.classList.add('no-events');
          form.classList.add('is-visible');
          count.setAttribute('aria-expanded', 'true');
        });

        count.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || (e.key === 'Tab' && !e.shiftKey)) {
            var firstLink = form.querySelector('a[data-swatch-link]');
            if (firstLink && form.classList.contains('is-visible')) {
              e.preventDefault();
              firstLink.focus();
            }
          }
        });

        // Safety net: re-ensure is-visible when focus enters the swatch form
        form.addEventListener('focusin', function() {
          form.classList.add('is-visible');
          productInfo.classList.add('no-events');
          count.setAttribute('aria-expanded', 'true');
        });
      });

      // Pattern B: Sibling swatches -- [data-sibling-count] triggers [data-sibling-fieldset]
      document.querySelectorAll('[data-sibling-count]').forEach(function(count) {
        if (count.hasAttribute('data-kb-init')) return;
        count.setAttribute('data-kb-init', '');
        count.setAttribute('tabindex', '0');
        count.setAttribute('role', 'button');
        count.setAttribute('aria-expanded', 'false');

        var productInfo = count.closest('[data-product-information]');
        if (!productInfo) return;
        var fieldset = productInfo.querySelector('[data-sibling-fieldset]');
        if (!fieldset) return;

        count.addEventListener('focus', function() {
          fieldset.classList.add('is-visible');
          count.setAttribute('aria-expanded', 'true');
        });

        count.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || (e.key === 'Tab' && !e.shiftKey)) {
            var firstSibling = fieldset.querySelector('[data-sibling-link]');
            if (firstSibling && fieldset.classList.contains('is-visible')) {
              e.preventDefault();
              firstSibling.focus();
            }
          }
        });

        // Safety net: re-ensure is-visible when focus enters the sibling fieldset
        fieldset.addEventListener('focusin', function() {
          fieldset.classList.add('is-visible');
          count.setAttribute('aria-expanded', 'true');
        });
      });

      // Make sibling divs keyboard navigable
      document.querySelectorAll('[data-sibling-link]').forEach(function(div) {
        if (div.hasAttribute('data-kb-init')) return;
        div.setAttribute('data-kb-init', '');
        div.setAttribute('tabindex', '0');
        div.setAttribute('role', 'link');

        // Set accessible name from tooltip or cutline
        var name = div.getAttribute('data-tooltip')
          || div.getAttribute('data-sibling-cutline')
          || '';
        if (name) div.setAttribute('aria-label', name);

        div.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var url = div.getAttribute('data-sibling-link');
            if (url) window.location.href = url;
          }
        });
      });
    }

    // Keep swatches/siblings visible while focus remains inside the product item
    document.addEventListener('focusout', function(e) {
      var productInfo = e.target.closest('[data-product-information]');
      if (!productInfo) return;

      // Delay to let the browser settle focus before checking
      setTimeout(function() {
        var newFocus = document.activeElement;
        if (productInfo.contains(newFocus)) return;

        // Focus left the product item -- hide swatches
        var form = productInfo.querySelector('[data-grid-swatch-form]');
        if (form) {
          form.classList.remove('is-visible');
          productInfo.classList.remove('no-events');
        }

        var fieldset = productInfo.querySelector('[data-sibling-fieldset]');
        if (fieldset) {
          fieldset.classList.remove('is-visible');
        }

        // Reset aria-expanded on triggers
        var swatchCount = productInfo.querySelector('[data-swatch-count]');
        if (swatchCount) swatchCount.setAttribute('aria-expanded', 'false');
        var siblingCount = productInfo.querySelector('[data-sibling-count]');
        if (siblingCount) siblingCount.setAttribute('aria-expanded', 'false');
      }, 150);
    });

    // Run on DOMContentLoaded and also observe for dynamically added products
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwatchTriggers);
    } else {
      initSwatchTriggers();
    }

    // Re-init when new product grid items are added (e.g. infinite scroll, AJAX)
    var gridObserver = new MutationObserver(function(mutations) {
      var hasNewItems = mutations.some(function(m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewItems) initSwatchTriggers();
    });

    var grids = document.querySelectorAll('[data-section-type]');
    grids.forEach(function(grid) {
      gridObserver.observe(grid, { childList: true, subtree: true });
    });
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
